import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageI } from 'src/app/auth/modelos/tokenstorage.inteface';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
pubNombreUsuario:String="";
pubIdUsuario:Number=0;


constructor(
  private tokenStorageService: TokenStorageService,
  private router:Router){


}


  ngOnInit(): void {
      let obj:  TokenStorageI = JSON.parse(sessionStorage.getItem('auth-user')+"");
   
    this.pubNombreUsuario=obj.nombre+"";
    this.pubIdUsuario=obj.idUsuario;
   
  }

  logout(){

    this.tokenStorageService.signOut();
    this.router.navigateByUrl('#/login');
  }


}
